import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const NAVY = '#001F3F';
const GOLD = '#B8860B';

export default function BookingSuccess() {
  const navigate = useNavigate();

  // Automatically redirect to the dashboard after 8 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/dashboard');
    }, 8000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div style={container}>
      <div style={card}>
        <div style={iconCircle}>✓</div>
        
        <h1 style={{ color: GOLD, fontSize: '2.5rem', fontWeight: '900', margin: '1rem 0', letterSpacing: '1px' }}>
          PAYMENT SUCCESSFUL
        </h1>

        <p style={message}>
          Your funds are now held securely in the <b>Esdras Vault (Escrow)</b>.
        </p>

        <div style={escrowBadge}>
          <span style={{ fontSize: '0.7rem', fontWeight: '900', color: GOLD }}>VAULT STATUS: SECURE</span>
        </div>
        
        <div style={infoBox}>
          <p style={{ margin: '0 0 10px 0', fontSize: '0.9rem', color: 'white' }}>
            The stylist has been notified via their <b>Monnify Sub-account</b>. 
          </p>
          <p style={{ margin: 0, fontSize: '0.75rem', opacity: 0.7 }}>
            Funds will only be released after you mark the session as complete. A 10% platform fee has been applied to this secure transaction.
          </p>
        </div>
        
        <button 
          onClick={() => navigate('/dashboard')} 
          style={homeBtn}
          onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
          onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
        >
          GO TO DASHBOARD
        </button>
        
        <div style={footerArea}>
          <p style={{ margin: 0, opacity: 0.5, fontSize: '0.8rem' }}>
            Redirecting to your dashboard automatically...
          </p>
          <div style={loadingBarContainer}>
            <div style={loadingBarFill}></div>
          </div>
        </div>
      </div>
    </div>
  );
}

// STYLES
const container = {
  height: '100vh',
  background: '#050a0f',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontFamily: 'Montserrat, sans-serif',
  padding: '20px'
};

const card = {
  background: NAVY,
  padding: '3.5rem 2.5rem',
  borderRadius: '40px',
  border: `2px solid ${GOLD}`,
  textAlign: 'center',
  maxWidth: '480px',
  width: '100%',
  boxShadow: '0 40px 80px rgba(0,0,0,0.6)',
  position: 'relative',
  overflow: 'hidden'
};

const iconCircle = {
  width: '90px',
  height: '90px',
  borderRadius: '50%',
  background: GOLD,
  color: 'black',
  fontSize: '2.8rem',
  display: 'grid',
  placeItems: 'center',
  margin: '0 auto 1.5rem',
  boxShadow: `0 0 40px ${GOLD}44`,
  fontWeight: '900'
};

const message = {
  fontSize: '1.1rem',
  color: 'white',
  opacity: 0.9,
  lineHeight: 1.6,
  marginBottom: '1rem'
};

const escrowBadge = {
  display: 'inline-block',
  padding: '6px 15px',
  borderRadius: '50px',
  background: 'rgba(184, 134, 11, 0.1)',
  border: `1px solid ${GOLD}44`,
  marginBottom: '1.5rem'
};

const infoBox = {
  background: 'rgba(255,255,255,0.03)',
  padding: '1.8rem',
  borderRadius: '24px',
  marginTop: '1rem',
  border: '1px solid rgba(255,255,255,0.08)',
  textAlign: 'left'
};

const homeBtn = {
  background: GOLD,
  color: 'black',
  padding: '1.2rem 3rem',
  border: 'none',
  borderRadius: '16px',
  fontWeight: '900',
  fontSize: '1rem',
  cursor: 'pointer',
  marginTop: '2.5rem',
  width: '100%',
  transition: 'all 0.3s ease',
  letterSpacing: '1px'
};

const footerArea = {
  marginTop: '2.5rem'
};

const loadingBarContainer = {
  width: '100px',
  height: '3px',
  background: 'rgba(255,255,255,0.1)',
  margin: '15px auto 0',
  borderRadius: '10px',
  overflow: 'hidden'
};

const loadingBarFill = {
  width: '100%',
  height: '100%',
  background: GOLD,
  animation: 'shrink 8s linear forwards'
};

// CSS Animation (Add to your global CSS or as a style tag)
// @keyframes shrink { from { width: 100%; } to { width: 0%; } }
